export const exportStageToBlob = async ({
  stage,
  scale,
  cardWidth,
  cardHeight,
  format = 'png'
}) => {
  if (!stage) return null;

  const exportScale = 1 / scale;

  const dataURL = stage.toDataURL({
    x: 0,
    y: 0,
    width: cardWidth,
    height: cardHeight,
    pixelRatio: exportScale,
    mimeType: format === 'jpg' ? 'image/jpeg' : 'image/png',
    quality: format === 'jpg' ? 0.95 : undefined
  });

  const res = await fetch(dataURL);
  return await res.blob();
};
